export default class JobOffer {
  constructor(
    public places: string[],
    public department: string,
    public contract: string,
    public terminability: string,
    private _element: HTMLElement
  ) {}

  public static parse(element: HTMLElement): JobOffer {
    let { place, department, contract, terminability } = element.dataset;

    let places: string[] = [];
    if (place) {
      places = place.split("|").map(place => place.trim());
    }

    if (department === undefined) {
      department = '';
    }

    if (contract === undefined) {
      contract = '';
    }

    if (terminability === undefined) {
      terminability = '';
    }

    return new JobOffer(places, department, contract, terminability, element);
  }

  public show(): void {
    this._element.style.display = "";
    this._element.hidden = false;
  }

  public hide(): void {
    this._element.style.display = "none";
    this._element.hidden = true;
  }
}
